var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cartCount()
    ? _c("div", { staticClass: "cart-summary" }, [
        _c("p", { staticClass: "text-right" }, [
          _c("b", [
            _vm._v(
              _vm._s(_vm.vignetteCount()) +
                " " +
                _vm._s(_vm.tollCount()) +
                ", " +
                _vm._s(_vm.uclower(_vm.$t("total"))) +
                " = " +
                _vm._s(_vm.cartTotal()) +
                " " +
                _vm._s(_vm.$tc("currency", _vm.cartTotal()))
            ),
            _vm.cartSMSTotal() > 0
              ? _c("span", [
                  _vm._v(
                    ", " +
                      _vm._s(_vm.uclower(_vm.$t("total_sms"))) +
                      " = " +
                      _vm._s(_vm.cartSMSTotal()) +
                      " " +
                      _vm._s(_vm.$tc("currency", _vm.cartSMSTotal()))
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t("cart")["empty"]))])])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }